import { withAppCrashIfException } from 'epic';
import { basketOptimizerEpic } from 'epic/advisory/basket/basket-optimizer.epic';
import { combineEpics } from 'redux-observable';

export const basketAdvisoryEpic = () => withAppCrashIfException('basketAdvisory', combineEpics(basketOptimizerEpic()));
